module.exports = __webpack_public_path__ + "img/overcast.ab73fff7.svg";